<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive :include="cachedViews">
      <component :is="Component" :key="route.fullPath" />
    </keep-alive>
  </router-view>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import {
  getWeixinAuthUrl,
  isWeChatWorkBrowser,
  getUrlParams,
} from '@/utils/weixin';
import { useUserStore } from '@/store/modules/user';
import { useCachedViewsStore } from '@/store/modules/cachedViews';
import { configJsSdk } from './utils/wxSdk';

const route = useRoute();
const userStore = useUserStore();
const cachedViewsStore = useCachedViewsStore();

// 使用 store 中的缓存视图列表
const cachedViews = computed(() => cachedViewsStore.getCachedViews);

// 记录上一个路由名称
let previousRouteName: string | symbol | null | undefined = route.name;

// 监听路由变化，实现动态缓存
watch(
  () => route.name,
  (to) => {
    // 如果从 area 返回 home，清除 area 的缓存
    if (previousRouteName === 'area' && to === 'home') {
      cachedViewsStore.removeCachedView('Area');
    }
    // 如果从其他页面进入 area，且 area 不在缓存列表中，则添加
    else if (to === 'area' && !cachedViews.value.includes('Area')) {
      cachedViewsStore.addCachedView('Area');
    }
    // 如果进入 search，添加 search 的缓存
    if (to === 'search' && !cachedViews.value.includes('Search')) {
      cachedViewsStore.addCachedView('Search');
    }
    // 确保 home 始终在缓存列表中
    if (to === 'home' && !cachedViews.value.includes('Home')) {
      cachedViewsStore.addCachedView('Home');
    }
    // 更新上一个路由名称
    previousRouteName = to;
  }
);

/*
// 存在code，说明是微信授权回调
let params = getUrlParams();
let code = params.code;
let share = params.share;
if (code) {
  userStore.setCode(code);
  // 传递给后端获取
  // 从地址栏删除 code 参数
  const url = new URL(window.location.href);
  url.searchParams.delete('code');
  history.replaceState({}, document.title, url.toString());
}
// 是微信环境并且没登录，构造授权链接[share分享链接不验证登录]
else if (!share && isWeChatWorkBrowser() && !userStore.getToken) {
  let url = getWeixinAuthUrl(
    'wwffe6ce656fb02bd9',
    '1000002',
    `${location.origin}/login`,
    'snsapi_privateinfo'
  );
  location.href = url;
} */

// 测试授权
// configJsSdk().then(()=>{

// })
</script>
<style></style>
